import React, { Component } from 'react';
import '../styles/Content.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import data from '../assets/data/data.json';

class Content extends Component {
  render() {
    return (
      <div className="Content">
        <div className="container">
          {/* Introduction & History */}
          <div className="row mt-4 mb-4">
            <div className="col">
              <p className="text-center">{ data["description"][0].content }</p>
            </div>
          </div>
          <div className="row mt-4 mb-4">
            <div className="col">
              <img src="./bag-icon-collection.png" alt="icon-collection" className="img-fluid" />
            </div>
          </div>
          <div className="row mt-4 mb-4">
            <div className="col">
              <p className="text-center">{ data["description"][1].content }</p>
            </div>
          </div>
          <div className="img-bg ph-bg-1">
            <div className="col">
            </div>
          </div>
          <div className="row mt-4 mb-4">
            <div className="col">
              <p className="text-center">{ data["description"][5].content }</p>
              <p className="text-center">{ data["description"][6].content }</p>
            </div>
          </div>
          {/* Timeline
          <hr className="hr1" />
          <div className="row mb-5">
              { 
                data["timeline"].map(function(tl){
                return <div className="col-sm-12 col-md-2">
                        <h2 className="text-center">{ tl.year }</h2>
                        <p className="text-center">{ tl.content }</p>
                      </div>
                })
              }
          </div> */}
        </div>
        {/* Hardware */}
        <div className="vid-container">
          {/* <div className="overlay"></div> */}
          <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
            <source src="mcyhw_test.mp4" type="video/mp4" />
          </video>
          <div className="container h-100">
            <div className="d-flex text-center h-100">
              <div className="my-auto w-100 text-white">
                <h1>Unparalleled Craftsmanship</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container mt-5">
            <div className="row pb-5">
              <div className="col-md-4 col-12">
                <img src="./mainline-mt.jpg" alt="hardware" className="img-fluid"/>
                <h2 className="pt-4">Materials</h2>
                <p className="pb-4">{ data["description"][7].content }</p>
              </div>
              <div className="col-md-4 col-12">
                <img src="./mainline-abs.jpg" alt="abs" className="img-fluid" />
                <h2 className="pt-4">ABS Plastic</h2>
                <p className="pb-4">{ data["description"][2].content }</p>
              </div>
              <div className="col-md-4 col-12">
                <img src="./square.png" alt="hardware" className="img-fluid"/>
                <h2 className="pt-4">Hardware</h2>
                <p>{ data["description"][3].content }</p>
              </div>
            </div>
          </div>

        {/* Gallery */}
        <div className="img-bg ph-bg-3">
          <div className="col">
          </div>
        </div>

        {/* Map & Link to New Page */}
        <div className="container">
          <div className="row text-center">
            <div className="col">
              <img src="./logochange-2.png" alt="logochange" className="img-fluid" />
            </div>
          </div>

          <div className="row mb-4">
            <div className="col text-center">
              <h3>Mainline Crafts is now<br /><strong>MCY Custom Case Corporation</strong></h3>
            </div>
          </div>
          
          <div className="row mt-4 justify-content-center">
            <div className="col">
              <iframe className="map-iframe"
                title="maps"
                frameBorder="0" 
                src="https://www.google.com/maps/embed/v1/place?key=
                AIzaSyCODv_vWrDz4EnmNYc9Kg9zffc87PDwK7U&q=275%2012th%20Street%20B%2C%20Wheeling%2C%20IL%2060090&zoom=15" >
              </iframe>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col">
              <p className="text-center">{ data["description"][4].content }</p>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col text-center">
            <a href="https://mcycustomcase.com/" className="btn btn-primary btn-lg" role="button" aria-pressed="true">Go To Website</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Content;


// WEBPACK FOOTER //
// ./src/components/Content.js